import { useVideoAd } from "../presentation/VideoAdContext";
import PlayerExco from "./exco";
import PlayerIMA from "./IMAPlayer";

export const DefaultPlayer = () => {
  const { state } = useVideoAd();
  if (state.phase === "loading") return null;

  if (state.runtime.player === "exco") return <PlayerExco />;

  return <PlayerIMA />;
};

export default DefaultPlayer;
